export default __webpack_public_path__ + "static/media/KZ.М.15.2285.af245c57.svg";